import { Component, OnInit } from '@angular/core';
import { BreakpointService, ProductFacetNavigationComponent, IconComponent } from '@spartacus/storefront';
import { Custom_ICON_TYPE } from '../../model/product-facet-navigation-icon.model';
import { EfaActiveFacetsComponent } from '../efa-active-facets/efa-active-facets.component';
import { EfaFacetListComponent } from '../efa-facet-list/efa-facet-list.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-product-facet-navigation',
    templateUrl: './efa-product-facet-navigation.component.html',
    imports: [IconComponent, EfaActiveFacetsComponent, EfaFacetListComponent, AsyncPipe, TranslatePipe]
})
export class EfaProductFacetNavigationComponent extends ProductFacetNavigationComponent {
  customIconTypes = Custom_ICON_TYPE;
  constructor(breakpointService: BreakpointService) {
    super(breakpointService)
  }

  ngOnInit(): void {
  }

}
